// extracted by mini-css-extract-plugin
export default {"mobileHeight":"screen and (max-height: 824px)","body":"ShowInfoPanel_body__-2sH5","heading":"ShowInfoPanel_heading__9Qi+E","subHeader":"ShowInfoPanel_subHeader__sfSLc"};